
import AdvancePaymentStartNow from "./advance-payment-start-now.vue";
import AdvancePaymentTransfer from "./advance-payment-transfer.vue";

export default {
  components: {
    AdvancePaymentStartNow,
    AdvancePaymentTransfer
  },
  created() {
    this.$nuxt.$on("show-advance-payment-transfer", () => {
      this.showAdvancePaymentTransfer = true;
    });
  },
  data() {
    return {
      showAdvancePaymentTransfer: false
    };
  }
};
